import { UserFactory } from "@/classes/abstractFactory";
import LoginService from "@/services/LoginService";
import RestService from "@/services/RestService";

const state = {
  user: createUser(localStorage.getItem("rawUser")),
  accessToken: localStorage.getItem("accessToken") || "", // get Item from localStorage,
};
RestService.setToken(state.accessToken);

function createUser(rawUserStr) {
  if (!rawUserStr) {
    return {};
  }
  const rawUser =
    typeof rawUserStr === "string" ? JSON.parse(rawUserStr) : rawUserStr;
  const builder = UserFactory.getUserBuilder();
  const user = builder
    .setFirstName(rawUser.first_name)
    .setLastName(rawUser.last_name)
    .setEmail(rawUser.email)
    .setUserId(rawUser.id)
    .seRole(rawUser.role)
    .setGrade(rawUser.grade)
    .setGuest(rawUser.guest)
    .build();
  return user;
}

const getters = {
  getUser: (state) => {
    return state.user;
  },
  getUserEmail: (state) => {
    return state?.user?.email;
  },
  hasToken: (state) => {
    return Boolean(state.accessToken);
  },
  getToken: (state) => {
    return state.accessToken;
  },
  isGuest: (state) => () => {
    return state.user.guest;
  },
  isTeacher(state) {
    return state.user.isTeacher();
  },
  isStudent(state) {
    return state.user.isStudent();
  },
  isParent(state) {
    return state.user.isParent();
  },
};
const actions = {
  async loginUser({ commit, dispatch }, payload) {
    const { email, password } = payload;
    const response = await LoginService.loginByEmail(email, password);
    const accessToken = response.data.token;
    const rawUser = response.data;
    rawUser.guest = false;
    commit("setAccessToken", accessToken);
    commit("setUser", rawUser);
    RestService.setToken(accessToken);
    dispatch("UserActivityStore/initStore", {}, { root: true });
  },
  logout({ commit }) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("rawUser");
    commit("setAccessToken", "");
    commit("setUser", {});
    RestService.setToken("");
    commit("LessonsStore/resetStore", null, { root: true });
  },
  createGuestUser({ commit }, payload) {
    const { token } = payload;
    commit("setAccessToken", token);
    commit("setGuest");
  },
};

const mutations = {
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken;
    localStorage.setItem("accessToken", accessToken); //add accessToken in LocalStorage
  },
  setUser(state, rawUser) {
    localStorage.setItem("rawUser", JSON.stringify(rawUser));
    state.user = createUser(rawUser);
  },
  setGuest(state) {
    const rawUser = {
      first_name: "",
      last_name: "",
      email: "",
      id: "1",
      role: 0,
      guest: true,
    };
    localStorage.setItem("rawUser", JSON.stringify(rawUser));
    state.user = createUser(rawUser);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
